module.exports = __webpack_public_path__ + "img/团队02.c9c9aa57.svg";